import React, { type FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from '@emotion/styled'
import { spacing } from '@retailer-platform/shared-components'
import FilterBar from 'legacy/components/FilterBar'
import DocumentTitle from 'legacy/components/DocumentTitle'
import AppFrame from 'legacy/components/AppFrame/AppFrame'
import { StoreGroupsListAddButton } from 'legacy/sections/store-groups/components/list/components/StoreGroupsListAddButton'
import { StoreGroupsListBreadcrumbs } from 'legacy/sections/store-groups/components/breadcrumbs/components/StoreGroupsListBreadcrumbs'
import {
  StoreGroupsListBody,
  type StoreGroupsListBodyProps,
} from 'legacy/sections/store-groups/components/list/components/StoreGroupsListBody'

interface Props extends StoreGroupsListBodyProps {}

const StyledNote = styled.div({
  paddingLeft: spacing.X28,
})

export const StoreGroupsListContent: FunctionComponent<Props> = props => (
  <AppFrame data-testid="list-store-groups">
    <DocumentTitle titleId="settings.storeGroups.title" />
    <AppFrame.Header title={<StoreGroupsListBreadcrumbs />} />
    <AppFrame.ContentBar>
      <FilterBar justifyContent="space-between">
        <StyledNote>
          <FormattedMessage id="settings.storeGroups.headerNote" />
        </StyledNote>
        <FilterBar.Section>
          <FilterBar.Items>
            <FilterBar.Item>
              <StoreGroupsListAddButton />
            </FilterBar.Item>
          </FilterBar.Items>
        </FilterBar.Section>
      </FilterBar>
    </AppFrame.ContentBar>
    <AppFrame.ContentBody>
      <StoreGroupsListBody {...props} />
    </AppFrame.ContentBody>
  </AppFrame>
)
